document.addEventListener('alpine:init', () => {
  // Create a shared registry of volume pricing components
  let volumePricingComponents = [];
  
  Alpine.data('volumePricing', () => ({
    isOpen: false,
    
    init() {
      // Add this component to the registry
      volumePricingComponents.push(this);
      
      // Handle clicks outside to close popup
      this.$nextTick(() => {
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.volume-pricing-note') && 
              !e.target.closest('.volume-pricing-popup')) {
            this.isOpen = false;
          }
        });
      });
    },
    
    toggle() {
      // If we're about to open this popup, close all others first
      if (!this.isOpen) {
        // Close all other popups
        volumePricingComponents.forEach(component => {
          if (component !== this && component.isOpen) {
            component.isOpen = false;
          }
        });
      }
      
      // Toggle this popup
      this.isOpen = !this.isOpen;
    },
    
    close() {
      this.isOpen = false;
    }
  }));
}); 